import { ListItem, ListItemText, TextField } from '@material-ui/core'
import { SearchOutlined } from '@material-ui/icons'
import { Autocomplete } from '@material-ui/lab'
import { WorkingStepIconSvg } from 'components/Common/WorkingSteps/WorkingStepIcon'
import { useLocalizedWorkingStepLabel } from 'components/Localization/useLocalizedWorkingStepLabel'
import { useTranslation } from 'react-i18next'
import { WorkingStepDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { alphabetcalSort } from 'utils/customSort'

export const WorkingStepAutoComplete = (props: {
  availableWorkingSteps: Array<WorkingStepDto>
  onOptionSelected: (workingStep: WorkingStepDto) => void
}) => {
  const { getLocalizedWorkingStep } = useLocalizedWorkingStepLabel()
  const { t } = useTranslation()

  const translateAndSort = (workingSteps: WorkingStepDto[]) =>
    workingSteps
      .map((item) =>
        Object.assign(item, {
          label: getLocalizedWorkingStep(item.primaryWorkingStep),
        })
      )
      .sort(alphabetcalSort('label'))

  return (
    <Autocomplete
      onChange={(event, value, reason) => {
        if (reason === 'select-option') {
          props.onOptionSelected(
            (value as WorkingStepDto[])[(value as WorkingStepDto[]).length - 1]
          )
        }
      }}
      multiple
      openOnFocus
      disableCloseOnSelect
      disableClearable
      autoHighlight
      options={translateAndSort(props.availableWorkingSteps)}
      filterSelectedOptions
      freeSolo
      forcePopupIcon
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          InputProps={{
            ...params.InputProps,
            startAdornment: <SearchOutlined color="action" />,
          }}
          placeholder={t('project:working-steps-available')}
        />
      )}
      renderOption={(option) => {
        return (
          <ListItem disableGutters component="div">
            <WorkingStepIconSvg
              attributes={{
                width: '32px',
              }}
              workingStepType={option.primaryWorkingStep}
            />
            <ListItemText
              style={{
                paddingLeft: '16px',
              }}
              primary={option.label}
            />
          </ListItem>
        )
      }}
      getOptionLabel={(option) => option.label}
      getOptionSelected={(option, value) => option.key === value.key}
    />
  )
}
